import { TableConditionApi } from 'cadenza/api-client/conditions/table-condition-api';

/** @see net/disy/services/conditions/AreaConditionEndpointController.java */
export class AreaConditionApi extends TableConditionApi {

  constructor ({ conditionSetId, conditionName, conditionId, conditionValuesSetHashGetter } = {}) {
    super({ conditionSetId, conditionName, conditionId, conditionValuesSetHashGetter }, '/areaConditionQuery');
  }

}
